module.exports = __webpack_public_path__ + "static/media/15.7928591e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/15.png
// module id = 1512
// module chunks = 0